import React from 'react'
import '../css file/fifthsection.css'
function FifthSection() {
    return (
        <>
            <div className="fifthsection-main-container">
                तथ्यांकहरू
            </div>
            <div className="fithsection-sub-container">
                <div className="fifthsection-sub-container1">
                    <div className="fifthsection-p">
                        Tourist Arrival By
                    </div>
                    <div className="fifth-section-p-sub-container">
                        <div className="fifthsection-p1">
                            Land
                        </div>
                        <div className="fifthsection-p1">
                            46955
                        </div>
                    </div>
                    <div className="fifth-section-p-sub-container">
                        <div className="fifthsection-p1">
                            Air
                        </div>
                        <div className="fifthsection-p1">
                            183130
                        </div>
                    </div>
                    <div className="fifth-section-p-sub-container">
                        <div className="fifthsection-p1">
                            Total
                        </div>
                        <div className="fifthsection-p1">
                            230085
                        </div>
                    </div>
                </div>
                <div className="fifthsection-sub-container2">
                    <div className="fifthsection-p fifthsection-p-second">
                        Tourist Category By Sex
                    </div>
                    <div className="fifth-section-p-sub-container">
                        <div className="fifthsection-p1">
                            Male
                        </div>
                        <div className="fifthsection-p1">
                            124048
                        </div>
                    </div>
                    <div className="fifth-section-p-sub-container">
                        <div className="fifthsection-p1">
                            Female
                        </div>
                        <div className="fifthsection-p1">
                            106037
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default FifthSection

